import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { iif, Observable, of } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';
import { CmRouteGuard } from '../models';
import { CmAuthService, CmSettingsService } from '../services';

@Injectable({
	providedIn: 'root',
})
export class CmAuthGuard extends CmRouteGuard implements CanActivate {
	constructor(private auth: CmAuthService, private settings: CmSettingsService, private router: Router) {
		super();
	}

	canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> {
		return this.auth.token$.pipe(
			mergeMap(token =>
				iif(
					() => !token,
					of(this.router.createUrlTree(this.settings.route(['login']))),
					this.checkAuthGuard$(route)
				)
			),
			take(1)
		);
	}

	private checkAuthGuard$(route: ActivatedRouteSnapshot) {
		return this.auth.guard$.pipe(
			map(guard =>
				this.passesGuardCheck(guard, route.routeConfig.data)
					? true
					: this.router.createUrlTree(this.settings.route(['access-denied']))
			)
		);
	}
}
